// 服务类型
export const AGENCYTYPE: { [key: string | number]: string } = {
  1: '投放提效工具',
  2: '私域运营工具',
  3: 'RTA投放工具',
  4: '内容服务',
  5: '数据服务',
  6: '代运营服务',
  7: '其他',
};

// 应用类型
export const APPTYPE: { [key: string | number]: string } = {
  1: '投放提效工具',
  2: '私域运营工具',
  3: 'RTA投放工具',
  4: '内容服务',
  5: '数据服务',
  6: '代运营服务',
  7: '其他',
};

export const COMPANYSCALE: { [key: string | number]: string } = {
  1: '1~10人',
  2: '10~50人',
  3: '50~100人',
  4: '100~300人',
  5: '300~500人',
  6: '500~1000人',
  7: '1000~2000人',
  8: '2000人以上',
};

export const CAPITAL: { [key: string | number]: string } = {
  1: '0-100万',
  2: '100-500万',
  3: '500-1000万',
  4: '1000万以上',
};

export const FINANCING: { [key: string | number]: string } = {
  1: '是',
  0: '否',
};
